import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { DomainGroupService } from '@client/app/services/entities/domain-group/domain-group.service';
import { DomainGroupRepoService } from '@client/app/services/api/domain-groups-repo/domain-group-repo.service';
import { NgForm } from '@angular/forms';
import { FormUtils } from '@client/ng2/shared/form-utils';
import { DomainGroupModel } from '@client/app/services/api/domain-groups-repo/domain-group-model';

@Component({
    selector: 'form-domain-groups-edit',
    templateUrl: '../_form.html',
    standalone: false,
})
export class FormDomainGroupsEditComponent implements OnInit, AfterViewInit {
    @Input() domainGroup!: DomainGroupModel;
    @Input() domain: any;
    @Input() monDialogId?: string;
    @Input() setForm?: (params: any) => void;

    saving = false;
    title = '';
    @ViewChild('groupForm') groupForm?: NgForm;

    get isDomainGroupComplete (): boolean {
        return this.domainGroupService.isDomainGroupComplete(this.domainGroup);
    }

    constructor (
        private domainGroupRepoService: DomainGroupRepoService,
        private translateService: TranslateService,
        private monDialog: MonDialog,
        private domainGroupService: DomainGroupService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.saving = false;
        this.title = this.translateService.getString('Edit: ') + this.domainGroup.title;

        this.domainGroupRepoService.get(this.domain.id, this.domainGroup.id).then((data: any) => {
            this.domainGroup = data;
        }, () => {});
    }

    ngAfterViewInit (): void {
        this.setForm?.({ id: this.monDialogId, form: this.groupForm });
    }

    close (data?: any): void {
        if (this.groupForm) {
            FormUtils.markFormAsPristine(this.groupForm);
        }
        this.monDialog.close(this.monDialogId, data || this.domainGroup);
    }

    save (): void {
        this.saving = true;
        this.domainGroup.rules = this.domainGroupService.cleanupRules(this.domainGroup.rules) as DomainGroupModel['rules'];
        this.domainGroupService
            .update(this.domain, this.domainGroup)
            .then((data: any) => {
                this.close(data);
            }, () => {})
            .finally(() => {
                this.saving = false;
            });
    }
}
